import React from 'react';

function TreeIcon(props: React.ComponentProps<'svg'>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            {...props}>
            <path d="M6.426,22.5V18.211H0L3,13.93H0L4.5,7.5H2.137L7.5,0l5.354,7.5H10.494L15,13.93H12l3,4.281H8.569V22.5Z"
                  transform="translate(4.5 0.5)"/>
        </svg>
    );
}

export default TreeIcon;